import { NavLink } from "react-router-dom";
import { publicUrlFor } from "../../../../globals/constants";
import { heroSlides } from "../../../../globals/neuron-content";
import { register } from "swiper/element/bundle";
register();

function SectionSlider2() {
  return (
    <div className="sx-bnr-2-wrap-outer home-2-slider">
      <swiper-container
        loop="true"
        space-between="30"
        effect="fade"
        navigation-next-el=".swiper-button-next"
        navigation-perv-el=".swiper-button-prev"
        pagination-el=".swiper-pagination"
        pagination-clickable="true"
        parallax="true"
        autoplay-delay="7000"
        autoplay-disable-on-interaction="true"
        class="swiper-wrapper"
      >
        {heroSlides.map((slide, idx) => (
          <swiper-slide
            key={idx}
            class="sx-bnr-2-wrap swiper-slide overlay-overlay"
            style={{
              backgroundImage: `linear-gradient(rgba(10, 15, 24, 0.72), rgba(10, 15, 24, 0.72)), url(${publicUrlFor(slide.bg)})`
            }}
          >
            <div className="container">
              <div className="sx-bnr-2-content">
                <span className="sx-bnr-2-small-title">{slide.smallTitle}</span>
                <h2 className="sx-bnr-2-large-title">{slide.title}</h2>
                <div className="sx-bnr-2-info">{slide.info}</div>
                <div className="sx-bnr-readmore">
                  <NavLink to={slide.cta.link} className="site-button sx-btn-primary icon"><i className="fa fa-long-arrow-right" />{slide.cta.label}</NavLink>
                </div>
              </div>
            </div>
          </swiper-slide>
        ))}
      </swiper-container>
      <div className="swiper-button-next" />
      <div className="swiper-button-prev" />
    </div>
  );
}

export default SectionSlider2;
